export enum ModalName {
  ADD_DEVICES = 'addDevices',
  AKTIIA_STATUS = 'aktiiaStatus',
  BP_CLASS = 'bpClass',
  CHANGE_USER_ROLE = 'changeUserRole',
  CONTACT_SUPPORT = 'contactSupport',
  CREATE_USER = 'createUser',
  DELETE_USER = 'deleteUser',
  EDIT_ACCOUNT = 'editAccount',
  FEATURE_FEEDBACK = 'featureFeedback',
  INVITE_PATIENT = 'invitePatient',
  LEAR_MORE = 'learnMore',
  LEAR_MORE_ABOUT_CUFF = 'learnMoreAboutCuff',
  ORDER_DEVICES = 'orderDevices',
  REMOVE_DEVICE = 'removeDevice',
  SEND_FEEDBACK = 'sendFeedback',
}
